import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { getUserData } from '../services/usuarios';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const [formularioRecorrido, setFormularioRecorrido] = useState(null);
    const [loading, setLoading] = useState(false);
    const [navigateRecorrido, setNavigateRecorrido] = useState(false);
    async function login() {
        window.location.assign('https://cidi.cba.gov.ar/Cuenta/Login?app=637');
    }

    function logout() {
        // Limpiar todas las credenciales y estados locales
        Cookies.remove('CiDi', { path: '/' });
        // Intentar eliminar también con dominio por si acaso está guardada así
        Cookies.remove('CiDi', { path: '/', domain: '.villamaria.gob.ar' });
        Cookies.remove('CiDi', { path: '/', domain: window.location.hostname });
        
        // Limpiar todos los estados relacionados con la sesión
        setUserData(null);
        setFormularioRecorrido(null);
        setNavigateRecorrido(false);
        setLoading(false);
        
        // Redirigir a CIDI para cerrar sesión en el sistema externo
        window.location.assign('https://cidi.cba.gov.ar/Cuenta/CerrarSesion');
    }

    function getCidiCookie() {
        const urlParams = new URLSearchParams(window.location.search);
        const cidiParam = urlParams.get('cidi');

        if (cidiParam) {
            // Guardar cookie sin dominio específico para que funcione en localhost y producción
            Cookies.set('CiDi', cidiParam, { expires: 1, path: '/' });
            return { value: cidiParam, fromUrl: true };
        }

        const cidiCookie = Cookies.get('CiDi');

        if (cidiCookie) {
            return { value: cidiCookie, fromUrl: false };
        }

        return null;
    }

    const checkCidiCookie = useCallback(async () => {
        const cidiResult = getCidiCookie();

        if (cidiResult) {
            setLoading(true);
            try {
                let response = await getUserData({ cidi: cidiResult.value });
                setUserData(response.usuario);

                if (response.formulario) {
                    setFormularioRecorrido(response.formulario);
                }

                // Si el CIDI vino de la URL, limpiar el parámetro de la URL sin recargar
                if (cidiResult.fromUrl) {
                    // Usar history.replaceState para cambiar la URL sin recargar la página
                    const cleanUrl = window.location.pathname;
                    window.history.replaceState({}, '', cleanUrl);
                    
                    // Si no está en '/', establecer el flag para navegar al home
                    if (window.location.pathname !== '/') {
                        setNavigateRecorrido(true);
                    }
                }
            } catch (error) {
                console.error('Error al obtener datos del usuario:', error);
                setUserData(null);
                Cookies.remove('CiDi', { path: '/' });
            } finally {
                setLoading(false);
            }
        } else {
            setUserData(null);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        checkCidiCookie();
    }, [checkCidiCookie]);

    const logged = userData !== null;

    return (
        <AppContext.Provider value={{
            logged,
            login,
            logout,
            loading,
            userData,
            formularioRecorrido,
            navigateRecorrido,
            setNavigateRecorrido
        }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    return useContext(AppContext);
};